/*
 * @@Description: 默认配置
 * @@Author: MuYang
 * @Date: 2021-08-25 20:24:32
 * @LastEditTime: 2021-10-16 16:37:16
 */
export const FIX = 'sy'
export const PREFIX = `${FIX}-table`
export const MIN_WIDTH = 96
// 渲染
export const cellForced = {
  // 内置多选
  selection: {
    renderHeader (h, { toggleAllSelection }) {
      return (
        <el-checkbox
          disabled={this.isAllDisabled}
          indeterminate={this.indeterminate}
          on-input={toggleAllSelection}
          value={this.isAllSelected}
          nativeOn-click={event => event.stopPropagation()}
        />
      )
    },
    renderCheckboxCell (h, { toggleRowSelection, disabled, value, tip }) {
      return (
        <el-tooltip effect="dark" content={tip} disabled={!tip}>
          <el-checkbox
            v-model={value}
            disabled={disabled}
            nativeOn-click={event => event.stopPropagation()}
            on-input={toggleRowSelection}
          />
        </el-tooltip>
      )
    },
    renderRadioCell (h, { value, disabled, toggleRowSelection }) {
      return (
        <el-radio
          value={this.radioSelect}
          disabled={disabled}
          label={value}
          nativeOn-click={event => event.stopPropagation()}
          on-input={toggleRowSelection}
        >
          <span></span>
        </el-radio>
      )
    },
    sortable: false,
    resizable: false
  },
  // 内置序号
  index: {
    renderHeader (h, { column }) {
      return column.label || '#'
    },
    renderCell (h, { index }) {
      return <span class={`${PREFIX}-row-index`}>{index}</span>
    },
    sortable: false
  },
  // 默认渲染
  default: {
    headerCell (h, { column }) {
      console.log(h, column)
    },
    rowCell (h, { row, column }) {
      return (
        <span calss={`${PREFIX}-body-cell-default`}>
          {row[column.dataIndex]}
        </span>
      )
    }
  },
  expand: {
    renderHeader (h, { column }) {
      return column.label || ''
    },
    renderCell (h, { row }) {
      return (
        <div>
          <i class='el-icon el-icon-arrow-right'></i>
        </div>
      )
    },
    sortable: false,
    resizable: false,
    className: 'el-table__expand-column'
  }
}

const createFn = (function () {
  const BASE_CONFIG = {
    realWidth: 40,
    hisWidth: 40,
    fixed: false,
    align: 'center'
  }

  return function (key, custom) {
    if (!key)
    {
      throw new Error('key in undefined')
    }
    const OBJ = {
      key: `${key}-column`,
      className: `${PREFIX}-${key}`
    }
    return Object.assign(OBJ, BASE_CONFIG, custom)
  }
})()

// 默认序号
export const INDEX_CONFIG = createFn('index', { render: val => val + 1 })
// 默认select
export const SELECT_CONFIG = createFn('selection', { selectType: 'checkbox' })

// 默认分页配置
export const paginationDefaultConfig = {
  pageSize: 10,
  currentPage: 1,
  background: true,
  layout: 'total, sizes, prev, pager, next, jumper',
  change: () => { }
}

// root级table
export const COMPONENTS_TABLE_NAMES = ['DTable', 'GTable']

// 特殊类型
export const SPECIAL_CULUMN_TYPES = ['index', 'selection', 'expand']